import XLSX from 'xlsx'

let state = {
  tabs: null,
  sheet: []
}

export default {
  data () {
    return {
      state: state
    }
  },
  methods: {
    getHeaderRow (sheet) {
      var headers = []
      var range = XLSX.utils.decode_range(sheet['!ref'])
      var C
      var R = range.s.r /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    fixdata (data) {
      var o = ''
      var l = 0
      var w = 10240
      for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    handleDrop (af) {
      var f = new Blob([af], { type: 'application/vnd.ms-excel' })
      var reader = new FileReader()
      var self = this
      this.state.sheet = []
      reader.onload = function () {
        var data = this.result
        var fixedData = self.fixdata(data)
        var workbook = XLSX.read(btoa(fixedData), {type: 'base64'})
        for (var i = 0; i < workbook.SheetNames.length; i++) {
          var sheetName = workbook.SheetNames[i]
          var worksheet = workbook.Sheets[sheetName]
          var results = XLSX.utils.sheet_to_json(worksheet, {
            blankRows: false,
            defval: ''
          })
          let headerRow = self.getHeaderRow(worksheet)
          self.state.sheet.push({sheetName: sheetName, headers: headerRow, tickets: results})
        }
      }
      reader.readAsArrayBuffer(f)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/reportMixin.js